export var toSelector = function (rule) { return ".".concat(rule.split(" ").join(".")); };
